import type { RHFGroupFieldValue } from '@/components/dynamic-filter/FilterFormGroup';
import type { ComponentRequisitionResponse } from '@/types/apps/component-requisition.type';
import type { ApiResponse, PaginatedResult } from '@/types/common/api.type';
import { BaseService } from '@/types/service/graphql-service.type';

export interface ComponentRequisitionGraphQLServiceInterface {}

type ComponentRequisitionListResponse = ApiResponse<
    PaginatedResult<ComponentRequisitionResponse>
>;

export class ComponentRequisitionMetricGraphQLService
    extends BaseService
    implements ComponentRequisitionGraphQLServiceInterface
{
    public getEntityName(): string {
        return 'partRequisition';
    }

    public getFields(): Record<string, any> {
        return {
            code: true,
            createdBy: true,
            createdDate: true,
            deletedAt: true,
            deletedBy: true,
            description: true,
            id: true,
            isDeleted: true,
            modifiedBy: true,
            modifiedDate: true,
            partRequisitionStatus: true,
            requisitionDate: true,
            partSuggestions: {
                id: true,
                suggestionDate: true,
            },
            oppCode: true,
            taskCheck: {
                assigneeName: true,
                assigneeId: true,
                code: true,
                ticket: {
                    code: true,
                    customer: {
                        name: true,
                        id: true,
                    },
                },
                device: {
                    id: true,
                    name: true,
                },
            },
        };
    }

    public index(query: string): Promise<ComponentRequisitionListResponse> {
        return this.fetchGqlList(query, this.getEntityName());
    }

    public getFilterByRole(): Record<string, RHFGroupFieldValue> {
        if (!this.getQueryById()) {
            return {};
        }

        return {
            getFilterByRole: {
                inputType: 'input',
                key: 'taskCheck.ticket.customerId',
                operator: '=',
                value: this.getQueryById(),
            },
        };
    }
}
